import { render, staticRenderFns } from "./DescriptionListConfigComponent.vue?vue&type=template&id=39f06a9c&"
import script from "./DescriptionListConfigComponent.vue?vue&type=script&lang=js&"
export * from "./DescriptionListConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports